// Build 20260912-353: stable constrained text layout.
// Build 20260912-352: preserve unchanged text nodes and reuse exact DOM text measurements.
// Build 20260912-351: share optical text bounds with the table number.
// Build 20260911-342: rich text ranges.
// Build 20260910-333: rotate text, pill and persisted output together.
(() => {
  if (window.__smoofTextStyleBridgeV16Build353) return;
  window.__smoofTextStyleBridgeV16Build353 = true;
  window.__smoofTextStyleBridgeV16Build352 = true;
  window.__smoofTextStyleBridgeV16Build351 = true;
  window.__smoofTextStyleBridgeV16Build342 = true;
  window.__smoofTextStyleBridgeV16 = true;
  window.__smoofTextStyleBridgeV15 = true;
  window.__smoofTextStyleBridgeV14 = true;
  window.__smoofTextStyleBridgeV13 = true;
  window.__smoofTextStyleBridgeV12 = true;
  window.__smoofTextStyleBridgeV11 = true;
  window.__smoofTextStyleBridgeV10 = true;
  document.documentElement.dataset.smoofTextRuntime = 'v2-37-stable-layout-20260912-353';

  const FONT_ID =
'052c068b-772b-4d04-af0d-56214e55cce3';

  const OUTER_RADIUS = 0.3534;
  const SAFETY_MARGIN_MM = 0;

  const SCALE = {
minimum: 0.1,
maximum: 12,
step: 0.1
  };

  const SNAP = {
x: 0.5,
threshold: 0.012
  };

  const FONT_STYLE_OPTIONS = Object.freeze(['Extra light', 'Extra light & Kursiv', 'Light', 'Light & Kursiv', 'Normal', 'Kursiv', 'Fett', 'Fett & Kursiv', 'Extra fett', 'Extra fett & Kursiv']);

  const LINES = [
{
  textId: '2375ec9f-695e-489a-ae63-4dc66fbcbb3f',
  styleId: '8cbb313f-ef10-40a4-a711-b894c8c15c2f',
  colorId: '1b10591e-29cb-455c-a22f-5d534a275702',
  fontSize: 0.047,
  legacyLetterSpacing: 0,
  fallback: 'EIGENER',
  defaultX: 0.5,
  defaultY: 0.2373
},
{
  textId: '5f47cc89-1d8f-4089-9919-514d4d1d3640',
  styleId: '999ff02f-9bc5-4ddf-996d-98459628780d',
  colorId: 'f9b38c60-cd0d-4740-94a4-5b235d7ab60c',
  fontSize: 0.047,
  legacyLetterSpacing: 0,
  fallback: 'TEXT',
  defaultX: 0.5,
  defaultY: 0.2883
},
{
  textId: 'aa1edcda-2cc3-4d6f-affd-d2db797ab684',
  styleId: 'c3b03f1a-c9a4-495e-b138-51bde4cfcbe8',
  colorId: 'dace7c47-c686-47bc-8580-4444848e6190',
  fontSize: 0.025,
  legacyLetterSpacing: 0.18,
  fallback: 'CUSTOM TEXT',
  defaultX: 0.5,
  defaultY: 0.3293
}
  ];

  const states = LINES.map(config => ({
x: config.defaultX,
y: config.defaultY,
scale: 1,
rotation: 0,
runs: [],
fitScale: 1,
pillVisible: false,
pillStrokeColor: '#000000',
pillFillColor: '#ffffff',
pillFillVisible: false,
pillStrokeWidth: 0.05,
pillPaddingX: 0.45,
pillPaddingY: 0.22,
textValue: null,
fontFamily: '',
letterSpacing: 0
  }));

  const PILL_DEFAULTS = Object.freeze({
pillVisible: false,
pillStrokeColor: '#000000',
pillFillColor: '#ffffff',
pillFillVisible: false,
pillStrokeWidth: 0.05,
pillPaddingX: 0.45,
pillPaddingY: 0.22
  });

  const requestedFontStyles = new Set();
  const EDITOR_SELECTION_EVENT =
'smoof:editor-select';

  let overlay = null;
  let guideX = null;
  let guideY = null;
  let currentStage = null;
  let renderPending = false;
  let activeDrag = null;
  let selectedEditorId = '';
  let editingIndex = null;
  let editingStartValue = '';
  let editingStartRuns = [];
  let syncingInlineIndex = null;
  let mobileToolbar = null;
  let mobileToolbarIndex = null;
  let textMeasurementCanvas = null;

  function textMeasurementContext() {
const canvas =
  textMeasurementCanvas ||
  document.createElement('canvas');

textMeasurementCanvas = canvas;

return canvas.getContext(
  '2d'
);
  }

  function finiteMetric(value, fallback = 0) {
const number = Number(value);
return Number.isFinite(number)
  ? number
  : fallback;
  }

  /*
   * Canvas zeichnet Text relativ zur typografischen Mitte, die sichtbare
   * Glyphenflaeche liegt darin aber je nach Schrift, Schnitt und Zeichen
   * asymmetrisch. Diese Messung bildet exakt die Ink Bounds der gemeinsamen
   * Canvas-Ausgabe ab, ohne deren kanonische Position zu veraendern.
   */
  function measureVisualTextBounds(frame) {
const richBounds = window.SmoofRichText?.bounds?.(frame?.querySelector('[data-smoof-text-content]'));
if (richBounds) return richBounds;
const content = frame?.querySelector(
  '[data-smoof-text-content], [data-smoof-number-content]'
);

const context =
  textMeasurementContext();

if (!content || !context) {
  return null;
}

const computed =
  getComputedStyle(content);

const fontSize =
  finiteMetric(
    Number.parseFloat(
      computed.fontSize
    ),
    16
  );

const lineHeight =
  finiteMetric(
    Number.parseFloat(
      computed.lineHeight
    ),
    fontSize * 1.08
  );

const spacing =
  computed.letterSpacing === 'normal'
    ? 0
    : finiteMetric(
        Number.parseFloat(
          computed.letterSpacing
        )
      );

context.save();
context.font = [
  computed.fontStyle || 'normal',
  computed.fontWeight || '400',
  `${fontSize}px`,
  computed.fontFamily || 'sans-serif'
].join(' ');
context.textBaseline = 'middle';
context.textAlign = 'left';

const lines = String(
  content.textContent || ' '
)
  .replace(/\r\n?/g, '\n')
  .split('\n');

const firstY =
  -(
    (
      lines.length - 1
    ) * lineHeight
  ) / 2;

let minimumX = Infinity;
let maximumX = -Infinity;
let minimumY = Infinity;
let maximumY = -Infinity;

lines.forEach((lineValue, lineIndex) => {
  const line = lineValue || ' ';
  const lineY =
    firstY +
    lineIndex * lineHeight;

  if (!spacing) {
    const metrics =
      context.measureText(line);

    const advance =
      finiteMetric(metrics.width);

    const left =
      -advance / 2 -
      finiteMetric(
        metrics.actualBoundingBoxLeft
      );

    const right =
      -advance / 2 +
      finiteMetric(
        metrics.actualBoundingBoxRight,
        advance
      );

    minimumX = Math.min(
      minimumX,
      left
    );

    maximumX = Math.max(
      maximumX,
      right
    );

    minimumY = Math.min(
      minimumY,
      lineY - finiteMetric(
        metrics.actualBoundingBoxAscent,
        fontSize / 2
      )
    );

    maximumY = Math.max(
      maximumY,
      lineY + finiteMetric(
        metrics.actualBoundingBoxDescent,
        fontSize / 2
      )
    );

    return;
  }

  const characters =
    Array.from(line);

  const measured =
    characters.map(character => ({
      metrics:
        context.measureText(character)
    }));

  const totalWidth =
    measured.reduce(
      (sum, entry) =>
        sum +
        finiteMetric(
          entry.metrics.width
        ),
      0
    ) +
    spacing * Math.max(
      0,
      measured.length - 1
    );

  let cursor =
    -totalWidth / 2;

  measured.forEach(entry => {
    const metrics =
      entry.metrics;

    minimumX = Math.min(
      minimumX,
      cursor - finiteMetric(
        metrics.actualBoundingBoxLeft
      )
    );

    maximumX = Math.max(
      maximumX,
      cursor + finiteMetric(
        metrics.actualBoundingBoxRight,
        metrics.width
      )
    );

    minimumY = Math.min(
      minimumY,
      lineY - finiteMetric(
        metrics.actualBoundingBoxAscent,
        fontSize / 2
      )
    );

    maximumY = Math.max(
      maximumY,
      lineY + finiteMetric(
        metrics.actualBoundingBoxDescent,
        fontSize / 2
      )
    );

    cursor +=
      finiteMetric(
        metrics.width
      ) + spacing;
  });
});

context.restore();

if (
  ![
    minimumX,
    maximumX,
    minimumY,
    maximumY
  ].every(Number.isFinite)
) {
  return null;
}

return {
  left: minimumX,
  top: minimumY,
  width: Math.max(
    1,
    maximumX - minimumX
  ),
  height: Math.max(
    1,
    maximumY - minimumY
  ),
  centerOffsetX:
    (
      minimumX + maximumX
    ) / 2,
  centerOffsetY:
    (
      minimumY + maximumY
    ) / 2
};
  }

  function syncVisualTextOutline(frame, logicalPillVisible) {
if (!frame) return null;

let outline = frame.querySelector(
  ':scope > [data-smoof-text-visual-outline]'
);

if (!outline) {
  outline =
    document.createElement('span');

  outline.dataset
    .smoofTextVisualOutline =
    'true';

  outline.setAttribute(
    'aria-hidden',
    'true'
  );

  frame.appendChild(outline);
}

/*
 * Beim Dateiimport werden Optionen, Tool-State und DOM in mehreren
 * Durchlaeufen hydriert. Chrome kann dabei kurzzeitig noch den alten
 * Inline-Displaywert der Pille liefern. Der Editor-State ist die
 * verbindliche Quelle; der DOM-Wert bleibt nur als Kompatibilitaets-
 * Fallback fuer fremde Aufrufer bestehen.
 */
const pillVisible =
  typeof logicalPillVisible === 'boolean'
    ? logicalPillVisible
    : frame.dataset.smoofPillVisible
      ? frame.dataset.smoofPillVisible === 'true'
      : frame.querySelector(
          '[data-smoof-text-pill]'
        )?.style.display !== 'none';

const metrics =
  measureVisualTextBounds(frame);

const useVisualOutline =
  Boolean(
    metrics &&
    !pillVisible &&
    frame.dataset.editing !== 'true'
  );

frame.dataset.smoofVisualOutline =
  String(useVisualOutline);

outline.hidden =
  !useVisualOutline;

if (!useVisualOutline) {
  return metrics;
}

const margin = 3;

outline.style.left =
  `calc(50% + ${metrics.left - margin}px)`;

outline.style.top =
  `calc(50% + ${metrics.top - margin}px)`;

outline.style.width =
  `${metrics.width + margin * 2}px`;

outline.style.height =
  `${metrics.height + margin * 2}px`;

return metrics;
  }

  function readVisualCenterOffset(frame) {
    const metrics = measureVisualTextBounds(frame);
    const angle = (Number(frame?.dataset.smoofTextRotation) || 0) * Math.PI / 180;
    const x = metrics?.centerOffsetX || 0;
    const y = metrics?.centerOffsetY || 0;
    return { x: x * Math.cos(angle) - y * Math.sin(angle),
      y: x * Math.sin(angle) + y * Math.cos(angle) };
  }

  function optionRoot(id) {
const roots = Array.from(
  document.querySelectorAll(
    `[data-option-id="${id}"]`
  )
);

return (
  roots.find(root => root.offsetParent !== null) ||
  roots[0] ||
  null
);
  }

  function getTextValue(config, index) {
const override = states[index]?.textValue;

if (typeof override === 'string') {
  return override || config.fallback;
}

const input =
  getEasifyTextInput(config);

return (
  input?.value.trim() ||
  input?.placeholder ||
  config.fallback
);
  }

  function getEnteredTextValue(config, index) {
const override = states[index]?.textValue;

if (typeof override === 'string') {
  return override;
}

const input = getEasifyTextInput(config);

return String(input?.value || '')
  .replace(/\r\n?/g, '\n')
  .trim();
  }

  function getEasifyTextInput(config) {
return optionRoot(config.textId)
  ?.querySelector(
    'input[type="text"], textarea'
  ) || null;
  }

  function setNativeInputValue(
input,
value
  ) {
if (!input) return;

const prototype =
  input instanceof HTMLSelectElement
    ? HTMLSelectElement.prototype
    : input instanceof HTMLTextAreaElement
    ? HTMLTextAreaElement.prototype
    : HTMLInputElement.prototype;

const descriptor =
  Object.getOwnPropertyDescriptor(
    prototype,
    'value'
  );

if (descriptor?.set) {
  descriptor.set.call(
    input,
    value
  );
} else {
  input.value = value;
}

input.dispatchEvent(
  new Event(
    'input',
    {
      bubbles: true
    }
  )
);
  }

  function getColor(id) {
return (
  optionRoot(id)
    ?.querySelector('input[type="color"]')
    ?.value ||
  '#000000'
);
  }

  function getSelectedValue(id, fallback = '') {
const root = optionRoot(id);

return (
  root
    ?.querySelector('select')
    ?.value ||
  root
    ?.querySelector('input[type="hidden"]')
    ?.value ||
  root
    ?.querySelector(
      'button[aria-haspopup="listbox"]'
    )
    ?.innerText.trim() ||
  fallback
);
  }

  function setEasifySelectedValue(
id,
value
  ) {
ensureNativeExtraOptions(id);
const root = optionRoot(id);

const nativeSelect =
  root?.querySelector('select');

const control =
  nativeSelect ||
  root?.querySelector(
    'input[type="hidden"]'
  );

if (!control) return;

let easifyValue = value;

if (nativeSelect) {
  const matchingOption =
    Array.from(
      nativeSelect.options
    ).find(option =>
      getToolbarStyleValue(
        option.textContent ||
          option.value
      ) === value
    );

  if (matchingOption) {
    easifyValue =
      matchingOption.value;
  }
}

setNativeInputValue(
  control,
  easifyValue
);

control.dispatchEvent(
  new Event(
    'change',
    {
      bubbles: true
    }
  )
);
  }

  function setEasifyColor(
id,
value,
commit = false
  ) {
const input = optionRoot(id)
  ?.querySelector(
    'input[type="color"]'
  );

if (!input) return;

setNativeInputValue(
  input,
  value
);

if (commit) {
  input.dispatchEvent(
    new Event(
      'change',
      {
        bubbles: true
      }
    )
  );
}
  }

  function normalizeRotation(value) {
    const angle = Number(value);
    return Number.isFinite(angle) ? ((angle % 360) + 360) % 360 : 0;
  }

  window.SmoofTextTools = {
  richState(index) {
    const state=states[index], config=LINES[index];
    if(!state||!config)return null;
    const canonicalStyle=getToolbarStyleValue(getSelectedValue(config.styleId,'Normal'));
    const resolved=getFontStyle(canonicalStyle);
    return {text:getTextValue(config,index),runs:state.runs||[],base:{fontFamily:getFont(index),canonicalStyle,fontWeight:resolved.weight,fontStyle:resolved.style,color:getColor(config.colorId)}};
  },
  setRichRuns(index,runs) {
    const state=states[index];if(!state)return false;
    state.runs=window.SmoofRichText.normalize(getTextValue(LINES[index],index),runs);
    render();window.SmoofDesignRenderer?.scheduleRender?.();return true;
  },
  setRotation(index, value) {
    const state = states[Number(index)];
    if (!state) return false;
    state.rotation = normalizeRotation(value);
    render();
    window.SmoofDesignRenderer?.scheduleRender?.();
    return state.rotation;
  },

  nudge(index, dx, dy) {
    const state = states[index];
    if (!state || editingIndex !== null || !getFrame(index)) return false;
    state.x += dx; state.y += dy;
    constrainState(index);
    render();
    window.SmoofDesignRenderer?.scheduleRender?.();
    return true;
  },
setColor(index, value, commit = false) {
  if(window.SmoofRichText?.selection(`text-${index}`))return window.SmoofRichText.apply(`text-${index}`,{color:value});
  if(!states[index])return false;
  states[index].runs=(states[index].runs||[]).map(({color,...run})=>run);
  const lineIndex = Number(index);
  const config = LINES[lineIndex];

  if (!config) return false;

  setEasifyColor(
    config.colorId,
    value,
    commit
  );

  selectTextFrame(lineIndex);
  scheduleRender();
  return true;
},

setStyle(index, value) {
  if(window.SmoofRichText?.selection(`text-${index}`))return window.SmoofRichText.apply(`text-${index}`,{fontStyle:value});

  const lineIndex = Number(index);
  const config = LINES[lineIndex];

  if (!config) return false;

  if (
    window.SmoofCustomFontRegistry?.isCustomFamily?.(
      states[lineIndex]?.fontFamily
    ) &&
    getToolbarStyleValue(value) !== 'Normal'
  ) {
    return false;
  }

  if (extraStyleStatus(getFont(lineIndex), value) !== 'available') return false;
  states[index].runs=(states[index].runs||[]).map(({fontStyle,...run})=>run);
  setEasifySelectedValue(
    config.styleId,
    getToolbarStyleValue(value)
  );

  selectTextFrame(lineIndex);
  scheduleRender();
  return true;
},

getFont(index) {
  return getFont(index);
},

freezeFonts() {
  const family = getGlobalFont();
  states.forEach(state => {
    if (!cleanFontFamily(state.fontFamily)) state.fontFamily = family;
  });
  return family;
},

setFont(index, value) {
  if(window.SmoofRichText?.selection(`text-${index}`))return window.SmoofRichText.apply(`text-${index}`,{fontFamily:value})?value:false;

  const lineIndex = Number(index);
  const state = states[lineIndex];
  const family = cleanFontFamily(value);
  if (!state || !family || !/^[a-z0-9 ._-]+$/i.test(family)) return false;
  state.runs=(state.runs||[]).map(({fontFamily,...run})=>run);
  state.fontFamily = family;
  if (window.SmoofCustomFontRegistry?.isCustomFamily?.(family)) {
    setEasifySelectedValue(LINES[lineIndex].styleId, 'Normal');
  }
  selectTextFrame(lineIndex);
  render();
  return family;
},

setLetterSpacing(index, value) {
  const lineIndex = Number(index);
  const state = states[lineIndex];
  if (!state) return false;
  state.letterSpacing = Math.round(clamp(value, -0.1, 0.5) * 100) / 100;
  selectTextFrame(lineIndex);
  render();
  return state.letterSpacing;
},

styleOptions: FONT_STYLE_OPTIONS,
styleOption,
syncStyleOptions,
extraStyleStatus,
requireExtraStyle,

normalizeStyle(value) {
  return getToolbarStyleValue(value);
},

resolveStyle(value) {
  return { ...getFontStyle(value) };
},

ensureFont(font, styleValue = 'Normal') {
  const family = cleanFontFamily(font);
  if (!family) return false;
  const custom = window.SmoofCustomFontRegistry?.isCustomFamily?.(family);
  const canonicalStyle = custom ? 'Normal' : getToolbarStyleValue(styleValue);
  const resolved = getFontStyle(canonicalStyle);
  ensureGoogleFont(family, resolved.weight, resolved.style);
  return {
    family,
    canonicalStyle,
    ...resolved
  };
},

measureVisualBounds(frame) {
  return measureVisualTextBounds(frame);
},

updateVisualOutline(frame, pillVisible) {
  return syncVisualTextOutline(frame, pillVisible);
},

visualCenterOffset(frame) {
  return readVisualCenterOffset(frame);
},

getHistoryState() {
  return states.map(state => ({ ...state }));
},

applyHistoryState(nextStates) {
  if (!Array.isArray(nextStates)) return false;

  nextStates.forEach((next, index) => {
    const state = states[index];
    if (!state || !next) return;
    const solution = next.layoutSolution;
    if (solution && solution.version === 1 && typeof solution.key === 'string' && solution.key.length < 20000 &&
        Number.isFinite(solution.width) && solution.width > 0 && solution.width <= 1 &&
        Number.isFinite(solution.fit) && solution.fit > 0 && solution.fit <= 1 &&
        Number.isFinite(solution.x) && Number.isFinite(solution.y)) {
      state.layoutSolution = {version:1,key:solution.key,width:solution.width,fit:solution.fit,x:solution.x,y:solution.y};
    } else delete state.layoutSolution;
    const oldContent = getContent(index);
    if (oldContent) stableLayouts.delete(oldContent);


    state.runs=window.SmoofRichText?.normalize?.(next.textValue ?? getTextValue(LINES[index],index),next.runs)||[];
    state.rotation = normalizeRotation(next.rotation);
    ['x', 'y', 'scale', 'fitScale', 'pillStrokeWidth', 'pillPaddingX', 'pillPaddingY'].forEach(key => {
      const value = Number(next[key]);
      if (Number.isFinite(value)) state[key] = value;
    });
    ['pillVisible', 'pillFillVisible'].forEach(key => {
      if (typeof next[key] === 'boolean') state[key] = next[key];
    });
    ['pillStrokeColor', 'pillFillColor'].forEach(key => {
      if (/^#[0-9a-f]{6}$/i.test(String(next[key]))) state[key] = next[key];
    });
    if (typeof next.textValue === 'string' || next.textValue === null) {
      state.textValue = next.textValue;
    }
    const family = cleanFontFamily(next.fontFamily);
    if (family && /^[a-z0-9 ._-]+$/i.test(family)) state.fontFamily = family;
    state.letterSpacing = Number.isFinite(Number(next.letterSpacing))
      ? Math.round(clamp(next.letterSpacing, -0.1, 0.5) * 100) / 100
      : LINES[index].legacyLetterSpacing;
  });

  activeDrag = null;
  setGuides(false, false);
  render();
  return true;
},

getPillState(index) {
  const state = states[Number(index)];
  return state ? { ...state } : null;
},

getConstraintRadius() {
  return getSafeRadius();
},

togglePill(index) {
  const state = states[Number(index)];
  if (!state) return false;
  state.pillVisible = !state.pillVisible;
  render();
  return state.pillVisible;
},

togglePillFill(index) {
  const state = states[Number(index)];
  if (!state) return false;
  state.pillFillVisible = !state.pillFillVisible;
  render();
  return state.pillFillVisible;
},

setPillColor(index, kind, value) {
  const state = states[Number(index)];
  if (!state || !/^#[0-9a-f]{6}$/i.test(String(value))) return false;
  state[kind === 'fill' ? 'pillFillColor' : 'pillStrokeColor'] = value;
  render();
  return true;
},

adjustPill(index, kind, amount) {
  const state = states[Number(index)];
  if (!state) return false;
  const limits = {
    stroke: ['pillStrokeWidth', 0.01, 0.2],
    paddingX: ['pillPaddingX', 0.1, 1.2],
    paddingY: ['pillPaddingY', 0.05, 0.8]
  };
  const spec = limits[kind];
  if (!spec) return false;
  state[spec[0]] = clamp(state[spec[0]] + Number(amount), spec[1], spec[2]);
  render();
  return state[spec[0]];
}
  };

  function getToolbarStyleValue(value) {
    const { weight, style } = getFontStyle(value);
    const base = {200:'Extra light',300:'Light',400:'Normal',700:'Fett',800:'Extra fett'}[weight];
    return style === 'italic' ? (base === 'Normal' ? 'Kursiv' : `${base} & Kursiv`) : base;
  }
  function cleanFontFamily(value) {
return String(value || '')
  .replace(/["']/g, '')
  .replace(/\s+/g, ' ')
  .trim()
  .slice(0, 100);
  }

  function getGlobalFont() {
return cleanFontFamily(
  getSelectedValue(
    FONT_ID,
    'Roboto'
  )
) || 'Roboto';
  }

  function getFont(index) {
return cleanFontFamily(
  states[Number(index)]?.fontFamily
) || getGlobalFont();
  }

  function getFontStyle(value) {
    const normalized = String(value || '').toLowerCase().replace(/[\s_-]+/g, ' ').trim();
    const light = /light|leicht/.test(normalized);
    const bold = /fett|bold/.test(normalized);
    const extra = /extra|ultra/.test(normalized);
    return { weight: light ? (extra ? '200' : '300') : bold ? (extra ? '800' : '700') : '400',
      style: /kursiv|italic/.test(normalized) ? 'italic' : 'normal' };
  }
  const extraStyleChecks = new Map();

  function extraStyleStatus(font, value) {
    const resolved = getFontStyle(value);
    if (!['200', '800'].includes(resolved.weight)) return 'available';
    const family = cleanFontFamily(font);
    if (!family || window.SmoofCustomFontRegistry?.isCustomFamily?.(family)) return 'unavailable';
    const key = `${family}|${resolved.weight}|${resolved.style}`;
    if (extraStyleChecks.has(key)) return extraStyleChecks.get(key);
    extraStyleChecks.set(key, 'pending');
    const italic = resolved.style === 'italic' ? 1 : 0;
    const url = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, '+')}:ital,wght@${italic},${resolved.weight}&display=swap`;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    fetch(url, { signal: controller.signal }).then(async response => {
      if (!response.ok) {
        extraStyleChecks.set(key, response.status === 400 ? 'unavailable' : 'error');
        return;
      }
      const css = await response.text();
      const blocks = css.match(/@font-face\s*\{[\s\S]*?\}/g) || [];
      const found = blocks.some(block => {
        const weights = (block.match(/font-weight\s*:\s*([^;]+)/i)?.[1] || '').trim().split(/\s+/).map(Number);
        const weight = Number(resolved.weight);
        const matchesWeight = weights.length === 1 ? weights[0] === weight : weights[0] <= weight && weights[1] >= weight;
        const style = block.match(/font-style\s*:\s*([^;]+)/i)?.[1]?.trim();
        return matchesWeight && style === resolved.style && /src\s*:\s*url\(/i.test(block);
      });
      extraStyleChecks.set(key, found ? 'available' : 'unavailable');
    }).catch(() => extraStyleChecks.set(key, 'error')).finally(() => {
      clearTimeout(timeout);
      scheduleRender();
      window.dispatchEvent(new CustomEvent('smoof:font-styles-ready', { detail: { family } }));
    });
    return 'pending';
  }

  async function requireExtraStyle(font, value) {
    let status = extraStyleStatus(font, value);
    if (status === 'pending') {
      await new Promise(resolve => {
        const ready = () => {
          if (extraStyleStatus(font, value) === 'pending') return;
          window.removeEventListener('smoof:font-styles-ready', ready);
          resolve();
        };
        window.addEventListener('smoof:font-styles-ready', ready);
        ready();
      });
      status = extraStyleStatus(font, value);
    }
    if (status !== 'available') {
      const english = String(document.documentElement.lang).toLowerCase().startsWith('en');
      throw new Error(english
        ? `The style “${value}” could not be verified for “${font}”. Please select an available style or reload and try again.`
        : `Der Schnitt „${value}“ konnte für „${font}“ nicht bestätigt werden. Bitte wählen Sie einen verfügbaren Schnitt oder laden Sie die Seite erneut.`);
    }
    return true;
  }

  function styleOption(font, value) {
    const status = extraStyleStatus(font, value);
    const english = String(document.documentElement.lang).toLowerCase().startsWith('en');
    const label = english ? value.replace('Extra light', 'Extra light').replace('Extra fett', 'Extra bold').replace('Fett', 'Bold').replace('Normal', 'Regular').replace('Kursiv', 'Italic') : value;
    const suffix = status === 'pending' ? (english ? 'checking…' : 'wird geprüft…')
      : status === 'unavailable' ? (english ? 'unavailable' : 'nicht verfügbar')
      : status === 'error' ? (english ? 'currently unavailable' : 'derzeit nicht verfügbar') : '';
    return { disabled: status !== 'available', label: suffix ? `${label} (${suffix})` : label };
  }

  function syncStyleOptions(select, font) {
    if (!select) return;
    Array.from(select.options).forEach(option => {
      const spec = styleOption(font, option.value);
      if (option.disabled !== spec.disabled) option.disabled = spec.disabled;
      if (option.textContent !== spec.label) option.textContent = spec.label;
    });
  }

  function ensureNativeExtraOptions(id) {
    const select = optionRoot(id)?.querySelector('select');
    if (!select) return;
    FONT_STYLE_OPTIONS.filter(value => value.startsWith('Extra')).forEach(value => {
      if (Array.from(select.options).some(option => getToolbarStyleValue(option.textContent || option.value) === value)) return;
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }
  function ensureGoogleFont(
font,
weight,
style
  ) {
const cleanFont = String(font || '')
  .replace(/["']/g, '')
  .trim();

if (!cleanFont) return;

if (
  window.SmoofCustomFontRegistry
    ?.isCustomFamily?.(cleanFont)
) {
  window.SmoofCustomFontRegistry
    .ensureLoaded(cleanFont)
    .then(scheduleRender)
    .catch(() => {});
  return;
}

const italic =
  style === 'italic' ? 1 : 0;

const requestKey =
  `${cleanFont}|${italic}|${weight}`;

if (requestedFontStyles.has(requestKey)) {
  return;
}

requestedFontStyles.add(requestKey);

const family =
  encodeURIComponent(cleanFont)
    .replace(/%20/g, '+');

const link =
  document.createElement('link');

link.rel = 'stylesheet';
link.href =
  `https://fonts.googleapis.com/css2?family=${family}:ital,wght@${italic},${weight}&display=swap`;

link.dataset.smoofGoogleFont =
  requestKey;

link.addEventListener(
  'load',
  scheduleRender,
  { once: true }
);

document.head.appendChild(link);
  }

  function getPrintDiameterMm() {
const variantDiameter =
  Number(
    window
      .SmoofProductVariant
      ?.get?.()
      ?.diameterMm
  );

if (
  Number.isFinite(
    variantDiameter
  ) &&
  variantDiameter >
    SAFETY_MARGIN_MM * 2
) {
  return variantDiameter;
}

const input = Array.from(
  document.querySelectorAll(
    'input[name="properties[Größe der Druckfläche]"]'
  )
).find(element =>
  element.offsetParent !== null ||
  element.type === 'hidden'
);

const value =
  input?.value || '80';

const match =
  String(value).match(/(\d+(?:[.,]\d+)?)/);

const diameter =
  Number(
    match?.[1]?.replace(',', '.')
  );

return (
  Number.isFinite(diameter) &&
  diameter > SAFETY_MARGIN_MM * 2
)
  ? diameter
  : 80;
  }

  function getSafeRadius() {
const diameter =
  getPrintDiameterMm();

return (
  OUTER_RADIUS *
  (
    1 -
    (
      SAFETY_MARGIN_MM * 2 /
      diameter
    )
  )
);
  }

  function getProductForm() {
return Array.from(
  document.querySelectorAll(
    'form[action*="/cart/add"]'
  )
).find(form =>
  form.querySelector('button[type="submit"]')
);
  }

  function findPropertyInput(form, name) {
return Array.from(
  form.querySelectorAll('input')
).find(input => input.name === name);
  }

  function setProperty(form, name, value) {
let input =
  findPropertyInput(form, name);

if (!input) {
  input =
    document.createElement('input');

  input.type = 'hidden';
  input.name = name;
  form.appendChild(input);
}

input.value = value;
  }

  function syncOrderProperties() {
const form = getProductForm();

if (!form) return;

states.forEach((state, index) => {
  const number = index + 1;

  setProperty(
    form,
    `properties[_SMOOF Text ${number} Inhalt]`,
    getTextValue(LINES[index], index)
  );

  setProperty(
    form,
    `properties[_SMOOF Text ${number} X]`,
    state.x.toFixed(4)
  );

  setProperty(
    form,
    `properties[_SMOOF Text ${number} Y]`,
    state.y.toFixed(4)
  );

  setProperty(form, `properties[_SMOOF Text ${number} Drehung]`, String(state.rotation));

  setProperty(
    form,
    `properties[_SMOOF Text ${number} Skalierung]`,
    state.scale.toFixed(4)
  );

  setProperty(
    form,
    `properties[_SMOOF Text ${number} Auto-Fit]`,
    state.fitScale.toFixed(4)
  );

  setProperty(
    form,
    `properties[_SMOOF Text ${number} Schriftart]`,
    getFont(index)
  );

  setProperty(
    form,
    `properties[_SMOOF Text ${number} Laufweite]`,
    state.letterSpacing.toFixed(2)
  );

  setProperty(form, `properties[_SMOOF Text ${number} Pill sichtbar]`, state.pillVisible ? 'Ja' : 'Nein');
  setProperty(form, `properties[_SMOOF Text ${number} Pill Konturfarbe]`, state.pillStrokeColor);
  setProperty(form, `properties[_SMOOF Text ${number} Pill Füllfarbe]`, state.pillFillColor);
  setProperty(form, `properties[_SMOOF Text ${number} Pill Füllung sichtbar]`, state.pillFillVisible ? 'Ja' : 'Nein');
  setProperty(form, `properties[_SMOOF Text ${number} Pill Konturstärke]`, (state.pillStrokeWidth * 100).toFixed(1));
  setProperty(form, `properties[_SMOOF Text ${number} Pill Padding X]`, (state.pillPaddingX * 100).toFixed(1));
  setProperty(form, `properties[_SMOOF Text ${number} Pill Padding Y]`, (state.pillPaddingY * 100).toFixed(1));
});

setProperty(
  form,
  'properties[_SMOOF Texteditor Version]',
  'placeholder-edit-v15'
);
  }

  function clamp(value, minimum, maximum) {
return Math.min(
  maximum,
  Math.max(minimum, value)
);
  }

  function getFrame(index) {
return overlay?.querySelector(
  `[data-smoof-text-frame="${index}"]`
);
  }

  function getEditorItemId(index) {
return `text-${index}`;
  }

  function applyEditorSelection(id) {
const nextId =
  String(id || '');

if (
  editingIndex !== null &&
  nextId !==
    getEditorItemId(editingIndex)
) {
  finishInlineEdit(true);
}

selectedEditorId = nextId;

// Zusatztexte liegen im selben Text-Overlay und verwenden dessen Auswahl-
// und Inline-Ebene. Die QR-Sperrzone wird in ihrem Positionsmodell erzwungen.
let textSelected = /^custom-text-[1-3]$/.test(nextId);

LINES.forEach((config, index) => {
  const frame = getFrame(index);

  if (!frame) return;

  const active =
    selectedEditorId ===
    getEditorItemId(index);

  frame.dataset.active =
    String(active);

  if (active) {
    textSelected = true;
  }
});

if (overlay) {
  overlay.style.zIndex =
    textSelected ? '80' : '70';
}

updateMobileToolbar(
  selectedEditorId
);

window.SmoofDesignRenderer?.scheduleRender?.();
  }

  function selectEditorItem(id) {
window.dispatchEvent(
  new CustomEvent(
    EDITOR_SELECTION_EVENT,
    {
      detail: {
        id: String(id || '')
      }
    }
  )
);
  }

  function selectTextFrame(index) {
selectEditorItem(
  getEditorItemId(index)
);
  }

  /*
   * Bei überlappenden Elementen wählt ein
   * weiterer kurzer Klick das nächste Element
   * unterhalb der aktuellen Auswahl.
   */
  function selectNextItemAtPoint(
clientX,
clientY,
currentId
  ) {
const items = [];

document
  .elementsFromPoint(
    clientX,
    clientY
  )
  .forEach(element => {
    const item =
      element.closest?.(
        '[data-smoof-editor-item]'
      );

    if (
      !item ||
      items.includes(item) ||
      item.offsetParent === null
    ) {
      return;
    }

    items.push(item);
  });

if (items.length < 2) return;

const currentIndex =
  items.findIndex(item =>
    item.dataset.smoofEditorItem ===
    currentId
  );

const next =
  items[
    (
      currentIndex + 1
    ) % items.length
  ];

if (next?.dataset.smoofEditorItem) {
  selectEditorItem(
    next.dataset.smoofEditorItem
  );
}
  }

  function getContent(index) {
return overlay?.querySelector(
  `[data-smoof-text-content="${index}"]`
);
  }

  function getInlineInput(index) {
return overlay?.querySelector(
  `[data-smoof-inline-text-input="${index}"]`
);
  }

  function getEditableTextValue(content) {
if (!content) return '';
if(content.dataset.smoofRichContent)return window.SmoofRichText.readDOM(content);

const value =
  typeof content.innerText === 'string'
    ? content.innerText
    : content.textContent || '';

return String(value)
  .replace(/\r\n?/g, '\n')
  .replace(/\u00a0/g, ' ');
  }

  function getNormalizedHalfSize(frame) {
const stageRect =
  currentStage?.getBoundingClientRect();

const frameRect =
  frame?.getBoundingClientRect();

const contentRect =
  frame
    ?.querySelector(
      '[data-smoof-text-content]'
    )
    ?.getBoundingClientRect();

if (
  !stageRect ||
  !frameRect ||
  !stageRect.width ||
  !stageRect.height
) {
  return {
    width: 0,
    height: 0
  };
}

return {
  width:
    Math.max(
      frameRect.width,
      contentRect?.width || 0
    ) /
    stageRect.width /
    2,

  height:
    Math.max(
      frameRect.height,
      contentRect?.height || 0
    ) /
    stageRect.height /
    2
};
  }

  const stableLayouts = new WeakMap();
  let activeLayout = null;

  function constrainState(index) {
const state = states[index];
const frame = getFrame(index);
const half =
  getNormalizedHalfSize(frame);
const spatial = window.SmoofSpatialConstraints;
if (!spatial) return;
const next = spatial.constrainRect({
  x: state.x,
  y: state.y,
  halfWidth: half.width,
  halfHeight: half.height,
  radius: getSafeRadius()
});
state.x = next.x;
state.y = next.y;
return next;
  }

  function setGuides(
showX,
showY,
y = 0.5,
x = SNAP.x
  ) {
const sharedGuides = window.SmoofAlignmentGuides;

if (sharedGuides) {
  if (guideX) guideX.style.display = 'none';
  if (guideY) guideY.style.display = 'none';
  if (showX) sharedGuides.showX(x);
  else sharedGuides.hideX();
  if (showY) sharedGuides.showY?.(y);
  else sharedGuides.hideY?.();
} else if (guideX) {
  guideX.style.left = `${x * 100}%`;
  guideX.style.display = showX ? 'block' : 'none';
}

if (guideY) {
  guideY.style.display =
    showY ? 'block' : 'none';

  guideY.style.top =
    `${y * 100}%`;
}
  }

  function updateGuideGeometry() {
if (!guideX) return;

const radius =
  getSafeRadius();

guideX.style.top =
  `${(0.5 - radius) * 100}%`;

guideX.style.bottom =
  `${(0.5 - radius) * 100}%`;
  }

  function applySnapping(index) {
const state = states[index];
const config = LINES[index];
const stageRect =
  currentStage?.getBoundingClientRect();

const opticalOffset =
  readVisualCenterOffset(
    getFrame(index)
  );

const opticalX =
  state.x +
  (
    stageRect?.width
      ? opticalOffset.x /
        stageRect.width
      : 0
  );

const opticalY =
  state.y +
  (
    stageRect?.height
      ? opticalOffset.y /
        stageRect.height
      : 0
  );

const sharedGuides = window.SmoofAlignmentGuides;
const guideAtX = sharedGuides
  ? sharedGuides.nearestX(opticalX, SNAP.threshold)
  : Math.abs(opticalX - SNAP.x) <= SNAP.threshold
    ? SNAP.x
    : null;
const snapX = Number.isFinite(guideAtX);

const sharedGuideAtY = sharedGuides?.nearestY?.(opticalY, SNAP.threshold);
const guideAtY = sharedGuides?.isAxisEnabled?.('y') === false ? null : Number.isFinite(sharedGuideAtY)
  ? sharedGuideAtY
  : Math.abs(state.y - config.defaultY) <= SNAP.threshold
    ? config.defaultY
    : null;
const snapY = Number.isFinite(guideAtY);

if (snapX) {
  state.x =
    guideAtX -
    (
      stageRect?.width
        ? opticalOffset.x /
          stageRect.width
        : 0
    );
}

if (snapY) {
  state.y = Number.isFinite(
    sharedGuideAtY
  )
    ? guideAtY -
      (
        stageRect?.height
          ? opticalOffset.y /
            stageRect.height
          : 0
      )
    : guideAtY;
}

setGuides(
  snapX,
  snapY,
  guideAtY,
  guideAtX
);
  }

  function updateFramePosition(
index,
shouldConstrain = false
  ) {
const frame = getFrame(index);
const state = states[index];

if (!frame) return;

frame.dataset.smoofTextRotation = String(state.rotation);
frame.style.transform = `translate(-50%, -50%) rotate(${state.rotation}deg)`;

if (shouldConstrain) {
  constrainState(index);
}

frame.style.left =
  `${state.x * 100}%`;

frame.style.top =
  `${state.y * 100}%`;
  }

  function getAvailableTextWidth(
index,
stageWidth
  ) {
const state = states[index];
const radius = getSafeRadius();

const verticalDistance =
  Math.abs(state.y - 0.5);

const circleHalfWidth =
  Math.sqrt(
    Math.max(
      0,
      radius * radius -
      verticalDistance *
        verticalDistance
    )
  );

const leftEdge =
  0.5 - circleHalfWidth;

const rightEdge =
  0.5 + circleHalfWidth;

const nearestHorizontalEdge =
  Math.min(
    state.x - leftEdge,
    rightEdge - state.x
  );

const availableHalfWidth =
  Math.max(
    0,
    nearestHorizontalEdge
  );

return (
  availableHalfWidth *
  2 *
  stageWidth
  );
  }

  // Cache only measured text widths, never design/geometry state. Font completion
  // invalidates fallback metrics; detached/remounted content has its own cache.
  const lineMeasurementCache = new WeakMap();
  let fontMeasurementRevision = 0;
  for (const event of ['loading', 'loadingdone', 'loadingerror']) {
    document.fonts?.addEventListener?.(event, () => { fontMeasurementRevision += 1; });
  }
  const measuredStyleProperties = [
    'font-family', 'font-size', 'font-weight', 'font-style', 'font-stretch',
    'font-variant', 'font-feature-settings', 'font-variation-settings',
    'font-kerning', 'font-optical-sizing', 'font-synthesis', 'letter-spacing',
    'word-spacing', 'text-transform', 'text-indent', 'text-rendering',
    'direction', 'writing-mode', 'padding-left', 'padding-right',
    'border-left-width', 'border-right-width', 'box-sizing', 'transform', 'zoom'
  ];

  function textMeasurementCache(content) {
const computed = getComputedStyle(content);
const signature = JSON.stringify([
  fontMeasurementRevision, document.fonts?.status,
  content.style.cssText, content.className, document.documentElement.lang,
  measuredStyleProperties.map(name => computed.getPropertyValue(name))
]);
let cache = lineMeasurementCache.get(content);
if (!cache || cache.signature !== signature) {
  cache = { signature, widths: new Map() };
  lineMeasurementCache.set(content, cache);
}
return cache;
  }

  function textMeasurementProbe(content, value) {
const probe = content.cloneNode(false);
probe.textContent = value || ' ';
Object.assign(probe.style, {position:'fixed',left:'-10000px',top:'0',width:'max-content',maxWidth:'none',whiteSpace:'pre',visibility:'hidden',pointerEvents:'none'});
return probe;
  }

  function measureTextLine(content, value, cache) {
const text = value || ' ';
// A face can become usable before FontFaceSet dispatches loadingdone.
// Keep measuring during that transition rather than reusing fallback widths.
const cacheable = !document.fonts || document.fonts.status === 'loaded';
if (cacheable && cache.widths.has(text)) return cache.widths.get(text);
const probe = textMeasurementProbe(content, value);
document.body.appendChild(probe);
const width = probe.getBoundingClientRect().width;
probe.remove();
// Bound retained strings even for long editing sessions.
if (cache.widths.size >= 128) cache.widths.clear();
if (cacheable) cache.widths.set(text, width);
return width;
  }

  function wrapTextValue(content, value, availableWidth) {
const paragraphs = String(value || '').replace(/\r\n?/g, '\n').split('\n');
const lines = [];
const cache = textMeasurementCache(content);
// For ordinary short paragraphs measure every possible greedy-wrap candidate
// together. All probes keep their original BODY parent and DOM measurement;
// reads happen after one append, with no intervening writes/layout flushes.
const wordRows = paragraphs.map(p=>p.trim().split(/\s+/).filter(Boolean));
if (document.fonts?.status === 'loaded' && wordRows.reduce((n,w)=>n+w.length*(w.length-1)/2,0)<=120) {
  const candidates = new Set();
  for (const words of wordRows) for(let start=0;start<words.length;start++) {
    let value=words[start];
    for(let end=start+1;end<words.length;end++){value+=' '+words[end];candidates.add(value);}
  }
  let missing=[...candidates].filter(value=>!cache.widths.has(value));
  if(cache.widths.size+missing.length>128){cache.widths.clear();missing=[...candidates];}
  if(missing.length){
    const probes=missing.map(value=>textMeasurementProbe(content,value));
    const fragment=document.createDocumentFragment();probes.forEach(probe=>fragment.appendChild(probe));
    document.body.appendChild(fragment);
    const widths=probes.map(probe=>probe.getBoundingClientRect().width);
    probes.forEach(probe=>probe.remove());
    if(document.fonts.status==='loaded')missing.forEach((value,i)=>cache.widths.set(value,widths[i]));
  }
}

paragraphs.forEach(paragraph => {
  const words = paragraph.trim().split(/\s+/).filter(Boolean);
  if (!words.length) {
    lines.push('');
    return;
  }

  let current = words.shift();
  words.forEach(word => {
    const candidate = `${current} ${word}`;
    if (measureTextLine(content, candidate, cache) <= availableWidth) {
      current = candidate;
    } else {
      lines.push(current);
      current = word;
    }
  });
  lines.push(current);
});

return lines.join('\n');
  }

  function updateLineAppearance(
index,
stageWidth,
font
  ) {
const config = LINES[index];
const state = states[index];
const content = getContent(index);

if (!content) return;

ensureNativeExtraOptions(config.styleId);
const selectedStyle =
  getSelectedValue(
    config.styleId,
    'Normal'
  );

const fontStyle =
  getFontStyle(selectedStyle);

ensureGoogleFont(
  font,
  fontStyle.weight,
  fontStyle.style
);

const activelyEditing =
  editingIndex === index &&
  document.activeElement === content;

const rawText = activelyEditing
  ? getEditableTextValue(content)
  : getTextValue(config, index);

// Rich paint owns its spans and caret. Do not destroy its unchanged DOM.
if (!activelyEditing && state.runs?.length && !window.SmoofRichText?.paint && content.textContent !== rawText) {
  content.textContent = rawText;
}

content.style.fontFamily =
  `"${font}", "Roboto", sans-serif`;

content.style.fontWeight =
  fontStyle.weight;

content.style.fontStyle =
  fontStyle.style;

content.style.fontSynthesis =
  window.SmoofCustomFontRegistry?.isCustomFamily?.(font)
    ? 'none'
    : 'weight style';

content.style.fontOpticalSizing =
  'auto';

content.style.letterSpacing =
  `${state.letterSpacing}em`;

content.style.color =
  getColor(config.colorId);

const frame = getFrame(index);

const toolbarStyle =
  frame?.querySelector(
    '[data-smoof-text-style-select]'
  );

syncStyleOptions(toolbarStyle, font);

const toolbarColor =
  frame?.querySelector(
    '[data-smoof-text-color-input]'
  );

if (
  toolbarStyle &&
  document.activeElement !==
    toolbarStyle
) {
  toolbarStyle.value =
    getToolbarStyleValue(
      selectedStyle
    );
}

if (
  toolbarColor &&
  document.activeElement !==
    toolbarColor
) {
  toolbarColor.value =
    getColor(config.colorId);
}

const baseFontSize =
  stageWidth *
  config.fontSize *
  state.scale * (activeLayout?.fit || 1);

const availableWidth = activeLayout?.width ??
  getAvailableTextWidth(
    index,
    stageWidth
  );

content.style.fontSize = `${baseFontSize}px`;
if (!activelyEditing && !state.runs?.length) {
  const wrappedText = wrapTextValue(content, rawText, availableWidth);
  if (!content.isContentEditable && (content.textContent !== wrappedText || content.childElementCount)) {
    content.textContent = wrappedText;
  }
}
content.style.maxWidth = `${availableWidth}px`;

state.fitScale = 1;

/* Wörter und manuelle Zeilenumbrüche dürfen auf mehrere Zeilen laufen.
 * Nur ein einzelnes untrennbares Wort wird weiterhin verkleinert. */
const naturalWidth = content.scrollWidth;

if (
  !state.runs?.length && naturalWidth > availableWidth &&
  availableWidth > 0
) {
  state.fitScale =
    Math.max(
      0.1,
      Math.min(
        1,
        availableWidth /
          naturalWidth
      )
    );

  content.style.fontSize =
    `${
      baseFontSize *
      state.fitScale
    }px`;
}

state.fitScale *= activeLayout?.fit || 1;

if(state.runs?.length || content.isContentEditable) window.SmoofRichText?.paint(content,rawText,state.runs);
else { content.style.removeProperty('white-space'); delete content._smoofRichItem; content.dataset.smoofRichContent='true'; }

updatePillAppearance(index);

updateInlineInputAppearance(
  index,
  stageWidth
);

updateTextGeometry(index);
  }

  function updatePillAppearance(index) {
const frame = getFrame(index);
const content = getContent(index);
const pill = frame?.querySelector(`[data-smoof-text-pill="${index}"]`);
const state = states[index];
if (!frame || !content || !pill || !state) return;
const fontSize = Number.parseFloat(content.style.fontSize) || 16;
frame.style.padding = state.pillVisible
  ? `${fontSize * state.pillPaddingY}px ${fontSize * state.pillPaddingX}px`
  : '2px 4px';
pill.style.display = state.pillVisible ? 'block' : 'none';
frame.dataset.smoofPillVisible = String(state.pillVisible);
pill.style.borderColor = state.pillStrokeColor;
pill.style.borderWidth = `${Math.max(1, fontSize * state.pillStrokeWidth)}px`;
pill.style.backgroundColor = state.pillFillVisible ? state.pillFillColor : 'transparent';
pill.dataset.smoofPillFillVisible = String(state.pillFillVisible);
  }

  function updateTextGeometry(index) {
const frame = getFrame(index);
const content = getContent(index);
const state = states[index];
if (!frame || !content || !state) return;

const contentRect = content.getBoundingClientRect();
const fontSize = Number.parseFloat(content.style.fontSize) || 16;
const paddingX = state.pillVisible ? fontSize * state.pillPaddingX : 4;
const availableWidth =
  Number.parseFloat(content.style.maxWidth) ||
  contentRect.width;

frame.style.width = 'fit-content';
frame.style.height = 'auto';
frame.style.maxWidth =
  `${Math.max(12, availableWidth + paddingX * 2 + 2)}px`;

syncVisualTextOutline(frame, state.pillVisible);
  }

  function updateInlineInputAppearance(
index,
stageWidth
  ) {
const config = LINES[index];
const input = getInlineInput(index);
const content = getContent(index);

if (!input || !content) return;

const easifyInput =
  getEasifyTextInput(config);

if (
  document.activeElement !== input
) {
  input.value =
    content.textContent || getTextValue(config, index) || '';
}

input.placeholder =
  config.fallback;

input.removeAttribute('maxlength');

input.style.fontFamily =
  content.style.fontFamily;

input.style.fontSize =
  content.style.fontSize;

input.style.fontWeight =
  content.style.fontWeight;

input.style.fontStyle =
  content.style.fontStyle;

input.style.fontSynthesis =
  content.style.fontSynthesis;

input.style.fontOpticalSizing =
  content.style.fontOpticalSizing;

input.style.letterSpacing =
  content.style.letterSpacing;

input.style.color =
  content.style.color;

input.style.minWidth = '0';
  }

  function syncInlineValue(
index,
value,
commit = false
  ) {
const easifyInput =
  getEasifyTextInput(
    LINES[index]
  );

if (!easifyInput) return;

const normalizedValue = String(value || '')
  .replace(/\r\n?/g, '\n');

states[index].runs=window.SmoofRichText?.reconcile?.(getTextValue(LINES[index],index),normalizedValue,states[index].runs)||[];
states[index].textValue = normalizedValue;
syncingInlineIndex = index;

setNativeInputValue(
  easifyInput,
  normalizedValue.replace(/\n+/g, ' ')
);

if (commit) {
  easifyInput.dispatchEvent(
    new Event(
      'change',
      {
        bubbles: true
      }
    )
  );
}

syncingInlineIndex = null;
syncOrderProperties();
  }

  function beginInlineEdit(index) {
if (
  editingIndex !== null &&
  editingIndex !== index
) {
  finishInlineEdit(true);
}

const frame = getFrame(index);
const content = getContent(index);
const easifyInput =
  getEasifyTextInput(
    LINES[index]
  );

if (
  !frame ||
  !content ||
  !easifyInput
) {
  return;
}

editingIndex = index;
const enteredText =
  getEnteredTextValue(
    LINES[index],
    index
  );

editingStartValue = enteredText;
editingStartRuns=states[index].runs.map(r=>({...r}));

frame.dataset.editing = 'true';
frame.dataset.editingPlaceholder =
  String(!enteredText);

/*
 * Der Fallback ist nur eine Vorschau und kein Kundeninhalt.
 * Beim zweiten Klick startet ein leeres Feld; vorhandener Kundentext bleibt.
 */
content.textContent = enteredText;
window.SmoofRichText?.begin(content,enteredText,states[index].runs);
content.contentEditable = 'true';
content.setAttribute('role', 'textbox');
content.setAttribute('aria-multiline', 'true');
content.setAttribute(
  'aria-label',
  `Textzeile ${index + 1} direkt bearbeiten`
);

/*
 * iOS Safari öffnet die Bildschirmtastatur
 * nur, wenn focus() synchron innerhalb des
 * echten Fingertipps ausgeführt wird.
 */
content.focus();

const selection = window.getSelection?.();
if (selection) {
  const range = document.createRange();
  range.selectNodeContents(content);
  range.collapse(false);
  selection.removeAllRanges();
  selection.addRange(range);
}

updateTextGeometry(index);
window.SmoofDesignRenderer?.scheduleRender?.();
  }

  function finishInlineEdit(
commit = true,
restoreStartValue = false
  ) {
if (editingIndex === null) return;

const index = editingIndex;
const frame = getFrame(index);
const content = getContent(index);

const value =
  restoreStartValue
    ? editingStartValue
    : getEditableTextValue(content);

editingIndex = null;
editingStartValue = '';

if (frame) {
  frame.dataset.editing = 'false';
  delete frame.dataset.editingPlaceholder;
}

if (content) {
  content.contentEditable = 'false';
  content.removeAttribute('role');
  content.removeAttribute('aria-multiline');
}

syncInlineValue(
  index,
  value,
  commit
);
if(restoreStartValue)states[index].runs=editingStartRuns;
editingStartRuns=[];

render();
window.SmoofDesignRenderer?.scheduleRender?.();
  }

  function changeScale(index, amount) {
const state = states[index];

state.scale = clamp(
  state.scale + amount,
  SCALE.minimum,
  SCALE.maximum
);

selectTextFrame(index);
render();
  }

  function resetLine(index) {
const config = LINES[index];
const state = states[index];
state.x = config.defaultX;
state.y = config.defaultY;
state.scale = 1;
state.rotation = 0;
state.fitScale = 1;
state.letterSpacing = 0;
Object.assign(state, PILL_DEFAULTS);

setGuides(false, false);
selectTextFrame(index);
render();
  }

  function finishDrag(event) {
if (!activeDrag) return;

const drag = activeDrag;
const frame =
  getFrame(drag.index);

if (frame) {
  frame.style.cursor = 'grab';
}

activeDrag = null;

if (
  frame?.hasPointerCapture?.(
    drag.pointerId
  )
) {
  frame.releasePointerCapture(
    drag.pointerId
  );
}

setGuides(false, false);
syncOrderProperties();

if (
  event?.type === 'pointerup' &&
  !drag.moved
) {
  beginInlineEdit(
    drag.index
  );
}
  }

  function createControlButton(
type,
label,
ariaLabel
  ) {
const button =
  document.createElement('button');

button.type = 'button';
button.textContent = label;

button.dataset.smoofTextControlButton =
  type;

button.setAttribute(
  'aria-label',
  ariaLabel
);

return button;
  }

  function createStyleControl(index) {
const wrapper =
  document.createElement('label');

wrapper.dataset.smoofTextStyleControl =
  String(index);

wrapper.setAttribute(
  'title',
  `Schriftschnitt von Textzeile ${index + 1}`
);

const label =
  document.createElement('span');

label.textContent = 'Aa';
label.dataset.smoofTextStyleLabel =
  'true';

const select =
  document.createElement('select');

select.dataset.smoofTextStyleSelect =
  String(index);

select.setAttribute(
  'aria-label',
  `Schriftschnitt von Textzeile ${index + 1}`
);

FONT_STYLE_OPTIONS.forEach(value => {
  const option =
    document.createElement('option');

  option.value = value;
  option.textContent = value;
  select.appendChild(option);
});

wrapper.append(
  label,
  select
);

return wrapper;
  }

  function createTextColorControl(index) {
const wrapper =
  document.createElement('label');

wrapper.dataset.smoofTextColorControl =
  String(index);

wrapper.setAttribute(
  'title',
  `Farbe von Textzeile ${index + 1}`
);

const input =
  document.createElement('input');

input.type = 'color';
input.dataset.smoofTextColorInput =
  String(index);

input.setAttribute(
  'aria-label',
  `Farbe von Textzeile ${index + 1}`
);

wrapper.appendChild(input);

return wrapper;
  }

  function isMobileEditor() {
return window.matchMedia(
  '(max-width: 749px)'
).matches;
  }

  function ensureMobileToolbar() {
if (
  mobileToolbar?.isConnected
) {
  return mobileToolbar;
}

mobileToolbar =
  document.createElement('div');

mobileToolbar.dataset
  .smoofMobileTextToolbar =
  'true';

mobileToolbar.hidden = true;

const styleControl =
  createStyleControl(0);

const colorControl =
  createTextColorControl(0);

const minus =
  createControlButton(
    'minus',
    '−',
    'Ausgewählte Textzeile verkleinern'
  );

const plus =
  createControlButton(
    'plus',
    '+',
    'Ausgewählte Textzeile vergrößern'
  );

const reset =
  createControlButton(
    'reset',
    '↺',
    'Ausgewählte Textzeile zurücksetzen'
  );

const styleSelect =
  styleControl.querySelector(
    '[data-smoof-text-style-select]'
  );

const colorInput =
  colorControl.querySelector(
    '[data-smoof-text-color-input]'
  );

mobileToolbar.append(
  styleControl,
  colorControl,
  minus,
  plus,
  reset
);

mobileToolbar.addEventListener(
  'pointerdown',
  event => {
    event.stopPropagation();
  }
);

styleSelect.addEventListener(
  'change',
  event => {
    event.stopPropagation();

    if (
      mobileToolbarIndex === null
    ) {
      return;
    }

    window.SmoofTextTools.setStyle(mobileToolbarIndex,styleSelect.value);

    scheduleRender();
  }
);

colorInput.addEventListener(
  'input',
  event => {
    event.stopPropagation();

    if (
      mobileToolbarIndex === null
    ) {
      return;
    }

    window.SmoofTextTools.setColor(mobileToolbarIndex,colorInput.value);

    scheduleRender();
  }
);

colorInput.addEventListener(
  'change',
  event => {
    event.stopPropagation();

    if (
      mobileToolbarIndex === null
    ) {
      return;
    }

    window.SmoofTextTools.setColor(mobileToolbarIndex,colorInput.value,true);
  }
);

minus.addEventListener(
  'click',
  event => {
    event.preventDefault();
    event.stopPropagation();

    if (
      mobileToolbarIndex !== null
    ) {
      changeScale(
        mobileToolbarIndex,
        -SCALE.step
      );
    }
  }
);

plus.addEventListener(
  'click',
  event => {
    event.preventDefault();
    event.stopPropagation();

    if (
      mobileToolbarIndex !== null
    ) {
      changeScale(
        mobileToolbarIndex,
        SCALE.step
      );
    }
  }
);

reset.addEventListener(
  'click',
  event => {
    event.preventDefault();
    event.stopPropagation();

    if (
      mobileToolbarIndex !== null
    ) {
      resetLine(
        mobileToolbarIndex
      );
    }
  }
);

document.body.appendChild(
  mobileToolbar
);

return mobileToolbar;
  }

  function updateMobileToolbar(
selectedId = selectedEditorId
  ) {
if (!isMobileEditor()) {
  if (mobileToolbar) {
    mobileToolbar.hidden = true;
  }

  mobileToolbarIndex = null;
  return;
}

const match =
  /^text-(\d+)$/.exec(
    String(selectedId || '')
  );

const index =
  match
    ? Number(match[1])
    : null;

if (
  index === null ||
  !LINES[index]
) {
  if (mobileToolbar) {
    mobileToolbar.hidden = true;
  }

  mobileToolbarIndex = null;
  return;
}

const toolbar =
  ensureMobileToolbar();

mobileToolbarIndex = index;
toolbar.hidden = false;

const styleSelect =
  toolbar.querySelector(
    '[data-smoof-text-style-select]'
  );

const colorInput =
  toolbar.querySelector(
    '[data-smoof-text-color-input]'
  );

if (
  document.activeElement !==
    styleSelect
) {
  styleSelect.value =
    getToolbarStyleValue(
      getSelectedValue(
        LINES[index].styleId,
        'Normal'
      )
    );
}

if (
  document.activeElement !==
    colorInput
) {
  colorInput.value =
    getColor(
      LINES[index].colorId
    );
}

syncStyleOptions(styleSelect, getFont(index));

styleSelect.setAttribute(
  'aria-label',
  `Schriftschnitt von Textzeile ${index + 1}`
);

colorInput.setAttribute(
  'aria-label',
  `Farbe von Textzeile ${index + 1}`
);
  }

  function attachFrameInteractions(
frame,
index
  ) {
const controls =
  frame.querySelector(
    '[data-smoof-text-controls]'
  );

const inlineInput =
  frame.querySelector(
    '[data-smoof-inline-text-input]'
  );

const content =
  frame.querySelector(
    '[data-smoof-text-content]'
  );

const styleSelect =
  controls.querySelector(
    '[data-smoof-text-style-select]'
  );

const colorInput =
  controls.querySelector(
    '[data-smoof-text-color-input]'
  );

const minus =
  controls.querySelector(
    '[data-smoof-text-control-button="minus"]'
  );

const plus =
  controls.querySelector(
    '[data-smoof-text-control-button="plus"]'
  );

const reset =
  controls.querySelector(
    '[data-smoof-text-control-button="reset"]'
  );

frame.addEventListener(
  'pointerdown',
  event => {
    if (
      event.target.closest(
        [
          '[data-smoof-text-controls]',
          '[data-smoof-inline-text-input]',
          '[data-smoof-text-content][contenteditable="true"]'
        ].join(',')
      )
    ) {
      return;
    }

    const itemId =
      getEditorItemId(index);

    /*
     * Erster Klick: nur auswählen.
     * Erst der nächste Drag bewegt die Zeile.
     */
    if (
      selectedEditorId !== itemId
    ) {
      selectTextFrame(index);
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const state = states[index];

    activeDrag = {
      index,
      pointerId: event.pointerId,
      startPointerX: event.clientX,
      startPointerY: event.clientY,
      startX: state.x,
      startY: state.y,
      moved: false
    };

    frame.setPointerCapture(
      event.pointerId
    );

    frame.style.cursor = 'grabbing';

    event.preventDefault();
  }
);

frame.addEventListener(
  'pointermove',
  event => {
    if (
      !activeDrag ||
      activeDrag.index !== index ||
      activeDrag.pointerId !==
        event.pointerId
    ) {
      return;
    }

    const stageRect =
      currentStage.getBoundingClientRect();

    const state = states[index];
    const distance =
      Math.hypot(
        event.clientX -
          activeDrag.startPointerX,
        event.clientY -
          activeDrag.startPointerY
      );

    if (distance > 3) {
      activeDrag.moved = true;
    }

    state.x =
      activeDrag.startX +
      (
        event.clientX -
        activeDrag.startPointerX
      ) / stageRect.width;

    state.y =
      activeDrag.startY +
      (
        event.clientY -
        activeDrag.startPointerY
      ) / stageRect.height;

    applySnapping(index);
    updateFramePosition(
      index,
      true
    );
    syncOrderProperties();

    event.preventDefault();
  }
);

frame.addEventListener(
  'pointerup',
  finishDrag
);

frame.addEventListener(
  'pointercancel',
  finishDrag
);

frame.addEventListener(
  'lostpointercapture',
  finishDrag
);

[minus, plus, reset].forEach(button => {
  button.addEventListener(
    'pointerdown',
    event => {
      event.stopPropagation();
    }
  );
});

minus.addEventListener(
  'click',
  event => {
    event.preventDefault();
    event.stopPropagation();
    changeScale(
      index,
      -SCALE.step
    );
  }
);

plus.addEventListener(
  'click',
  event => {
    event.preventDefault();
    event.stopPropagation();
    changeScale(
      index,
      SCALE.step
    );
  }
);

reset.addEventListener(
  'click',
  event => {
    event.preventDefault();
    event.stopPropagation();
    resetLine(index);
  }
);

inlineInput.addEventListener(
  'pointerdown',
  event => {
    event.stopPropagation();
  }
);

inlineInput.addEventListener(
  'input',
  () => {
    syncInlineValue(
      index,
      inlineInput.value
    );

    scheduleRender();
  }
);

inlineInput.addEventListener(
  'keydown',
  event => {
    if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      finishInlineEdit(true);
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      finishInlineEdit(
        true,
        true
      );
    }
  }
);

inlineInput.addEventListener(
  'blur',
  () => {
    if (editingIndex === index) {
      finishInlineEdit(true);
    }
  }
);

content.addEventListener(
  'pointerdown',
  event => {
    if (editingIndex === index) {
      event.stopPropagation();
    }
  }
);

content.addEventListener(
  'input',
  () => {
    if (editingIndex !== index) return;

    frame.dataset.editingPlaceholder =
      'false';

    syncInlineValue(
      index,
      getEditableTextValue(content)
    );

    updateTextGeometry(index);
    window.SmoofDesignRenderer?.scheduleRender?.();
  }
);

content.addEventListener(
  'keydown',
  event => {
    if (
      event.key === 'Enter' &&
      (event.metaKey || event.ctrlKey)
    ) {
      event.preventDefault();
      finishInlineEdit(true);
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      finishInlineEdit(true, true);
    }
  }
);

content.addEventListener(
  'blur',
  () => {
    if (editingIndex === index) {
      finishInlineEdit(true);
    }
  }
);

styleSelect.addEventListener(
  'change',
  event => {
    event.stopPropagation();

    window.SmoofTextTools.setStyle(index,styleSelect.value);

    selectTextFrame(index);
    scheduleRender();
  }
);

colorInput.addEventListener(
  'input',
  event => {
    event.stopPropagation();

    window.SmoofTextTools.setColor(index,colorInput.value);

    selectTextFrame(index);
    scheduleRender();
  }
);

colorInput.addEventListener(
  'change',
  event => {
    event.stopPropagation();

    window.SmoofTextTools.setColor(index,colorInput.value,true);
  }
);
  }

  function removeOverlay() {
overlay?.remove();

if (mobileToolbar) {
  mobileToolbar.hidden = true;
}

overlay = null;
guideX = null;
guideY = null;
currentStage = null;
activeDrag = null;
editingIndex = null;
editingStartValue = '';
mobileToolbarIndex = null;
  }

  function ensureOverlay(stage) {
if (
  overlay?.isConnected &&
  currentStage === stage
) {
  return;
}

removeOverlay();

overlay =
  document.createElement('div');

overlay.dataset.smoofTextOverlay =
  'true';

Object.assign(overlay.style, {
  position: 'absolute',
  display: 'block',
  inset: '0',
  zIndex: '70',
  pointerEvents: 'none',
  overflow: 'hidden'
});

guideX =
  document.createElement('div');

guideX.dataset.smoofTextSnapGuide =
  'x';

guideX.setAttribute(
  'aria-hidden',
  'true'
);

guideY =
  document.createElement('div');

guideY.dataset.smoofTextSnapGuide =
  'y';

guideY.setAttribute(
  'aria-hidden',
  'true'
);

overlay.append(
  guideX,
  guideY
);

LINES.forEach((config, index) => {
  const frame =
    document.createElement('div');

  frame.dataset.smoofTextFrame =
    String(index);

  frame.dataset.smoofEditorItem =
    getEditorItemId(index);

  frame.dataset.active =
    'false';

  frame.dataset.editing =
    'false';

  const content =
    document.createElement('span');

  content.dataset.smoofTextContent =
    String(index);

  const pill = document.createElement('span');
  pill.dataset.smoofTextPill = String(index);

  const inlineInput =
    document.createElement('textarea');

  inlineInput.rows = 1;
  inlineInput.inputMode = 'text';
  inlineInput.enterKeyHint = 'enter';
  inlineInput.autocomplete = 'off';
  inlineInput.spellcheck = true;

  inlineInput.setAttribute(
    'autocapitalize',
    'sentences'
  );

  inlineInput.dataset
    .smoofInlineTextInput =
    String(index);

  inlineInput.setAttribute(
    'aria-label',
    `Textzeile ${index + 1} direkt bearbeiten`
  );

  const controls =
    document.createElement('div');

  controls.dataset.smoofTextControls =
    'true';

  controls.append(
    createStyleControl(index),
    createTextColorControl(index),
    createControlButton(
      'minus',
      '−',
      `Textzeile ${index + 1} verkleinern`
    ),
    createControlButton(
      'plus',
      '+',
      `Textzeile ${index + 1} vergrößern`
    ),
    createControlButton(
      'reset',
      '↺',
      `Textzeile ${index + 1} zurücksetzen`
    )
  );

  frame.append(
    pill,
    content,
    inlineInput,
    controls
  );

  overlay.appendChild(frame);

  attachFrameInteractions(
    frame,
    index
  );
});

stage.appendChild(overlay);
currentStage = stage;

applyEditorSelection(
  selectedEditorId
);
updateGuideGeometry();
  }

  function render() {
const marker =
  document.querySelector(
    '#smoof-preview-extension'
  );

const stage =
  document.querySelector(
    '.po-livePreview-stage .konvajs-content'
  );

if (!marker || !stage) {
  removeOverlay();
  return;
}

ensureOverlay(stage);
updateGuideGeometry();

const stageWidth =
  stage.getBoundingClientRect().width;

if (!stageWidth) return;

LINES.forEach((config, index) => {
  const content = getContent(index), state = states[index];
  if (!content) return;
  const font = getFont(index);
  const keyParts = [getTextValue(config,index), font, stageWidth, fontMeasurementRevision,
    document.fonts?.status, state.scale, state.rotation, state.letterSpacing, state.runs,
    state.pillVisible, state.pillPaddingX, state.pillPaddingY, state.pillStrokeWidth,
    getSelectedValue(config.styleId,'Normal'), window.SmoofQrGeometryTools?.getState?.(), getSafeRadius()];
  const key = JSON.stringify(keyParts);
  const solutionKey = JSON.stringify(keyParts.filter((_,i)=>i!==3 && i!==4));
  let layout = stableLayouts.get(content);
  if (!layout || layout.key !== key || state.x !== layout.x || state.y !== layout.y || content.isContentEditable) {
    const saved = !layout && !content.isContentEditable && document.fonts?.status === 'loaded' ? state.layoutSolution : null;
    layout = {key, x:state.x, y:state.y, history:[], fit:1};
    if (saved?.key === solutionKey && saved.x === state.x && saved.y === state.y) {
      layout.width = saved.width * stageWidth;
      layout.fit = saved.fit;
      layout.restoring = true;
    }
    delete state.layoutSolution;
    stableLayouts.set(content,layout);
  }
  activeLayout = layout.width ? layout : null;
  updateLineAppearance(index,stageWidth,font);
  if (layout.restoring) {
    // Give remounted theme styles one render turn to settle before validating
    // an already verified saved solution; transient padding must not shrink it.
    updateFramePosition(index,false);
    layout.restoring=false;
    scheduleRender();
    state.layoutSolution={version:1,key:solutionKey,width:layout.width/stageWidth,fit:layout.fit,x:state.x,y:state.y};
    activeLayout=null;
    return;
  }
  updateFramePosition(index,true);
  const result = constrainState(index);
  const signature = JSON.stringify([state.x,state.y,content.textContent,content.style.fontSize]);
  const cycle = layout.history.length >= 2 && signature === layout.history[layout.history.length-2] && signature !== layout.history[layout.history.length-1];
  // Preserve the established layout path until it cycles or cannot fit. Then
  // solve against one wrap width; changing position must not change that width.
  if (!content.isContentEditable && (cycle || result?.valid === false || layout.width)) {
    layout.width ||= 2 * getSafeRadius() * stageWidth;
    activeLayout = layout;
    for (let attempt=0; attempt<32; attempt++) {
      updateLineAppearance(index,stageWidth,font);
      const placement=constrainState(index);
      updateFramePosition(index,false);
      if (!placement || placement.valid) break;
      layout.fit *= .92;
    }
  }
  layout.x=state.x; layout.y=state.y;
  if (layout.width) state.layoutSolution={version:1,key:solutionKey,width:layout.width/stageWidth,fit:layout.fit,x:state.x,y:state.y};
  else delete state.layoutSolution;
  layout.history.push(signature); if(layout.history.length>2)layout.history.shift();
  activeLayout=null;
});

updateMobileToolbar();
syncOrderProperties();

marker.dataset.smoofTextStatus =
  'active';

marker.dataset.smoofTextVersion =
  'placeholder-edit-v15';
  }

  function scheduleRender() {
if (renderPending) return;

renderPending = true;

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    renderPending = false;
    render();
  });
});
  }

  function settleImportedTextGeometry() {
scheduleRender();

const fontReady =
  document.fonts?.ready;

if (
  fontReady &&
  typeof fontReady.then === 'function'
) {
  fontReady.then(() => {
    scheduleRender();
    window.setTimeout(
      scheduleRender,
      80
    );
  });
}
  }

  window.addEventListener(
EDITOR_SELECTION_EVENT,
event => {
  applyEditorSelection(
    event.detail?.id
  );
}
  );

  window.addEventListener(
'smoof:editor-reset-all',
() => {
  activeDrag = null;

  states.forEach(
    (state, index) => {
      const config =
        LINES[index];

      state.x =
        config.defaultX;

      state.y =
        config.defaultY;

      state.scale = 1;
      state.rotation = 0;
      state.fitScale = 1;
      state.runs = [];
      state.fontFamily = '';
      state.letterSpacing = 0;
      Object.assign(state, PILL_DEFAULTS);
    }
  );

  setGuides(false, false);
  selectEditorItem('');
  render();
  syncOrderProperties();
}
  );

  window.addEventListener(
'smoof:editor-reset-layout',
() => {
  activeDrag = null;

  states.forEach(
    (state, index) => {
      const config = LINES[index];
      state.x = config.defaultX;
      state.y = config.defaultY;
      state.scale = 1;
      state.rotation = 0;
      state.fitScale = 1;
    }
  );

  setGuides(false, false);
  selectEditorItem('');
  render();
  syncOrderProperties();
}
  );

  if (
!window.__smoofEditorOutsideSelectionV1
  ) {
window.__smoofEditorOutsideSelectionV1 =
  true;

document.addEventListener(
  'pointerdown',
  event => {
    const target = event.target;

    if (
      target instanceof Element &&
      target.closest(
        [
          '[data-smoof-editor-item]',
          '[data-smoof-guide-button]',
          '[data-smoof-reset-button]',
          '[data-smoof-guide-visibility-button]',
          '[data-smoof-guide-legend]',
          '[data-smoof-mobile-text-toolbar]'
        ].join(',')
      )
    ) {
      return;
    }

    window.dispatchEvent(
      new CustomEvent(
        EDITOR_SELECTION_EVENT,
        {
          detail: {
            id: ''
          }
        }
      )
    );
  },
  true
);
  }

  document.addEventListener(
'input',
event => {
  const changedIndex = LINES.findIndex(config =>
    optionRoot(config.textId)?.contains(event.target)
  );

  if (changedIndex >= 0 && syncingInlineIndex !== changedIndex) {
    states[changedIndex].textValue = null;
  }

  scheduleRender();
},
true
  );

  document.addEventListener(
'change',
scheduleRender,
true
  );

  window.addEventListener(
'smoof:qr-geometry-change',
scheduleRender
  );

  window.addEventListener(
'smoof:design-file-loaded',
settleImportedTextGeometry
  );

  document.fonts?.addEventListener?.(
'loadingdone',
scheduleRender
  );

  document.addEventListener(
'click',
scheduleRender,
true
  );

  new MutationObserver(scheduleRender)
.observe(document.body, {
  childList: true,
  subtree: true
});

  window.setInterval(
scheduleRender,
500
  );

  scheduleRender();
})();
